import MsDyn365 from '@msdyn365-commerce/core';
import {IProductDetails,IProductBonusItems, IProductBonusWithBrandName } from '../modules/mfrm-cart/mfrm-cart';
import {IMFIBonusItemsResponse, IMFIGetBonusCouponsDetailsResponse} from '../actions/BonusItemDataServiceEntities.g';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import { setCookie } from '../common/cookies/cookie-utils';

export interface IMFRMDateGroupedProducts {
    dateStr: string;
    days?: string;
    productVariantRecordIds: number[];
    productItemIds: string[];
    productsType: string;
}

export interface IExpressFlow {
    paymentEdit: boolean
}

export interface ICartProductPrice {
    variantRecordId?: number;
    price?: number;
}

/** interface for parcel inventory details */
export interface IParcelInventoryDetails {
    itemId: string | undefined;
    location: string | undefined;
    productId: string | undefined;
    quantity: string | undefined;
}

const getSetLocalStorage = (key: string, getSet: string, valueToSet?: any, returnType?: any) => {
    if (MsDyn365.isBrowser) {
        switch (getSet) {
            case 'set':
                return localStorage.setItem(key, JSON.stringify(valueToSet || returnType));
            case 'get':
                return JSON.parse(localStorage.getItem(key) || '[]');
            default:
                return returnType;
        }
    } else {
        return returnType;
    }
};

export const getSetProductData = (getSet: string, products?: IProductDetails[]) => {
    products?.length && products.length > 0 && setCoreProductCookie(products); // Set cookie if it has core products
    return getSetLocalStorage('product_details', getSet, products, []);
};

// Following function sets cookie to check if cart has core item; Cookie is needed to access it on server side for skeleton on checkout
const setCoreProductCookie = (products: IProductDetails[]) => {
    for (const psp of products) {
        if (psp.typeOfProduct === 'Core' || psp.typeOfProduct === 'core') {
            setCookie('has-core-product', true);
            return;
        }
    }
    setCookie('has-core-product', false);
};

export const getSetProductSpec = (getSet: string, products?: IProductDetails[]) => {
    return getSetLocalStorage('product_specification', getSet, products, []);
};

export const getSetPromoCodeApplyList = (getSet: string) => {
    return getSetLocalStorage('promo_code_apply_list', getSet, [], []);
};

export const getSetPromoCode = (getSet: string) => {
    return getSetLocalStorage('promoCode', getSet, [], []);
};

export const getSetGrandTotal = (getSet: string, total?: string) => {
    return getSetLocalStorage('grand_total', getSet, total, 0);
};

export const getSetBonusItemProd = (getSet: string, globalBonusItems?: IMFIBonusItemsResponse[])=>{
    return getSetLocalStorage('BonusItemProduct', getSet, globalBonusItems, []);
};

export const getSetSelectedBonasItem = (getSet: string, bonusItemArray?: IProductBonusItems[]) => {
    return getSetLocalStorage('selectedBonasItems', getSet, bonusItemArray, []);
};

export const getSetBonusCouponDetail = (getSet: string, getCoupons?: IMFIGetBonusCouponsDetailsResponse[])=>{
    return getSetLocalStorage('bonusCouponsDetail', getSet, getCoupons, []);
};

export const getSetPrevBonasModalState = (getSet: string, previousBonasModal?: IProductBonusItems[]) => {
    return getSetLocalStorage('previousBonasModalState', getSet, previousBonasModal, []);
};

export const getSetBonusItemBrandName = (getSet: string, bonusItemsBrandName?: IProductBonusWithBrandName[]) => {
    return getSetLocalStorage('bonusItmesWithBrand', getSet, bonusItemsBrandName, []);
};

export const getSetDateGroupedProducts = (getSet: string, products?: IMFRMDateGroupedProducts[]) => {
    return getSetLocalStorage('date_grouped_products', getSet, products, []);
};

export const getSetExpressFlow = (getSet: string, express?: IExpressFlow) => {
    return getSetLocalStorage('express_flow', getSet, express, []);
};
export const getSetWmapCartLines = (getSet: string, products?: { product: SimpleProduct, count: number }[]) => {
    return getSetLocalStorage('wmapCartLines', getSet, products, []);
};

export const getSetCartProductPrice = (getSet: string, priceDetails?: ICartProductPrice[]) => {
     return getSetLocalStorage('cart_product_price', getSet, priceDetails, []);
};
export const getSetParcelInventoryData = (getSet: string, details?: IParcelInventoryDetails[]) => {
    return getSetLocalStorage('parcel_inventory_details', getSet, details, []);
};